import { render, staticRenderFns } from "./ftTemplateElement.vue?vue&type=template&id=d4027eae&scoped=true&"
import script from "./ftTemplateElement.vue?vue&type=script&lang=js&"
export * from "./ftTemplateElement.vue?vue&type=script&lang=js&"
import style0 from "./ftTemplateElement.vue?vue&type=style&index=0&id=d4027eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4027eae",
  null
  
)

export default component.exports